(function() {
  'use strict';

  angular.module('app').controller('FeedbackWizardSignupController', FeedbackWizardSignupController);

  FeedbackWizardSignupController.$inject = [
    '$rootScope',
    '$routeParams',
    '$scope',
    '$window',
    '$translate',
    'UserService',
    '$location',
    '$timeout',
    'SelectService',
    '$uibModal',
    'blockUI',
    'SettingsService'
  ];

  function FeedbackWizardSignupController(
      $rootScope,
      $routeParams,
      $scope,
      $window,
      $translate,
      UserService,
      $location,
      $timeout,
      SelectService,
      $uibModal,
      blockUI,
      SettingsService) {

    $scope.model = {
      name: '',
      login: '',
      password: '',
      country: '',
      terms: false,
      pincode: '',
      step: 0
    };

    $scope.data = {};
    $scope.getCountriesList = SelectService.getCountriesList;
    $scope.getLocalizedPath = getLocalizedPath;

    $scope.inlineMessage = '';
    $scope.pincodeRequests = 0;
    $scope.phoneValid = false;

    $rootScope.PAGE.style = 'no-menu bg-white';
    var block_register = blockUI.instances.get('registration');

    $scope.getLegalLinks = function() {
      SettingsService.GetLegalLinks(function(success, response) {
        if (success) {
          $scope.terms_of_service_url = response.terms_of_service_business_url;
        }
      });
    };

    $scope.getLegalLinks();
    initController();

    var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
      $scope.getCountriesList();
    });

    $scope.$on('$destroy', unbindTranslateChangeSuccess);

    function initController() {
      initFieldsValues();
      $scope.getCountriesList();
    }

    function initFieldsValues() {
      for (var i in $routeParams)
        $scope.model[i] = $routeParams[i];
    }

    function sendCodeToEmail() {
      var sendCodeToEmailParams = {
        login: $scope.model.login,
        password: $scope.model.password,
        country: ''
      };

      block_register.start();

      if ($scope.pincodeRequests < 2) {
        UserService.RequestPinv2(sendCodeToEmailParams, function(success, response) {
          if (success) {
            $scope.model.step = 1;
            $scope.pincodeRequests++;

            if ($scope.pincodeRequests < 2) {
              $scope.model.counter = 60;
              $scope.onTimeout = function() {
                if ($scope.model.counter === 1) {
                  $scope.resentPincodeTimeout = true;
                  $timeout.cancel(smsTimeout);
                } else {
                  $scope.model.counter--;
                  smsTimeout = $timeout($scope.onTimeout, 1000);
                }
              };
              var smsTimeout = $timeout($scope.onTimeout, 1000);
            }

          } else {
            var isInlineMessage = response.code == 1 || response.code == 2 || response.code == 4 || response.code == 5 || response.code ==
                113;

            if (response.info && response.info.business === false)
              $location.path('/signin').search(
                  {
                    redirect: '/feedback/sources',
                    p: $scope.model.phone,
                    su: 'true'
                  }
              );

            if (isInlineMessage) {
              $scope.inlineMessage = response.message;
            }
          }
          block_register.stop();
        });
      } else {
        $scope.model.step = 1;
        block_register.stop();
      }
    }

    $scope.register = function() {
      const form = $scope.form;
      switch ($scope.model.step) {
        case 0:
          if (form.login.$valid &&
              form.password.$valid &&
              form.name.$valid &&
              form.terms.$valid) {
            var checkParams = {
              value: $scope.model.login
            };

            block_register.start();
            UserService.validateEmail(checkParams, function(success, response) {
              if (success) {
                sendCodeToEmail();
              } else {
                if ([1, 26].indexOf(response.code) !== 1) {
                  $scope.inlineMessage = response.message;
                }
              }
              block_register.stop();
            });
          } else {
            form.login.$dirty
                = form.password.$dirty
                = form.name.$dirty
                = form.terms.$dirty
                = true;
          }
          break;
        case 1:
          if (form.pincode.$valid) {
            var registerParams = {
              login: $scope.model.login,
              password: $scope.model.password,
              name: $scope.model.name,
              country: '',
              pincode: $scope.model.pincode
            };

            block_register.start();
            UserService.Registerv2(registerParams, function(success, response) {
              if (success) {
                UserService._storeUserPublic(response);
                $rootScope.$broadcast('user-register');
                $location.path('/feedback/wizard');
              } else {
                if (showError(response.code)) {
                  $scope.inlineMessage = response.message;
                }
              }
              block_register.stop();
            });
          } else {
            form.pincode.$dirty = true;
          }
          break;
      }
    };

    $scope.onBackClick = function(step) {
      $scope.model.step = step;
      $scope.inlineMessage = '';

      if ($scope.pincodeRequests > 1 && step === 1) {
        $scope.resentPincodeTimeout = false;
        $scope.model.counter = 60;
      }
    };

    $scope.onRemoveInlineMessageClick = function() {
      $scope.inlineMessage = '';
    };
    $scope.onPasswordGenerate = function(form) {
      var pwd = angular.element('input[id="password"]');
      pwd.attr('type', 'text');

      var specials = '#$&*()_[]~';
      var lowercase = 'abcdefghijklmnopqrstuvwxyz';
      var uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var numbers = '0123456789';
      var all = specials + lowercase + uppercase + numbers;

      var password = '';
      password += pickCharacter(specials, 1);
      password += pickCharacter(lowercase, 1);
      password += pickCharacter(uppercase, 1);
      password += pickCharacter(numbers, 1);
      password += pickCharacter(all, 11, 12);
      password = shufflePassword(password);

      $scope.model.password = password;
      form.password.$dirty = true;
    };

    function pickCharacter(str, min, max) {
      var n, chars = '';

      if (typeof max === 'undefined')
        n = min;
      else
        n = min + Math.floor(Math.random() * (max - min + 1));

      for (var i = 0; i < n; i++)
        chars += str.charAt(Math.floor(Math.random() * str.length));

      return chars;
    };

    function shufflePassword(str) {
      var array = str.split('');
      var tmp, current, top = array.length;

      if (top) while (--top) {
        current = Math.floor(Math.random() * (top + 1));
        tmp = array[current];
        array[current] = array[top];
        array[top] = tmp;
      }

      return array.join('');
    };
    $scope.requestPin = function() {
      $scope.resentPincodeTimeout = false;

      var params = {
        login: $scope.model.login,
        password: $scope.model.password,
        country: ''
      };

      block_register.start();
      UserService.RequestPinv2(params, function(success, response) {
        if (success) {
          $scope.pincodeRequests++;
        } else {
          if (showError(response.code)) {
            $scope.inlineMessage = response.message;
          }
        }
        block_register.stop();
      });
    };

    function showError(code) {
      return [1, 2, 3, 4, 5].indexOf(code) !== -1;
    }

    $rootScope.$watch('COUNTRIES[LANG]', function(newValue, oldValue, scope) {
      var lang = $rootScope.LANG;
      $scope.getLegalLinks();

      if (newValue) {
        $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[lang]);

        var l = $scope.data.countriesList;
        for (var i in l)
          if (l[i].current)
            $scope.data.currentCountry = l[i];

        if (!$scope.data.currentCountry)
          $scope.data.currentCountry = l[0];
      }
    }, true);

    $scope.$watch('data.currentCountry', function(newValue, oldValue) {
      if (newValue && !$scope.phoneValid) {
        $scope.model.country = $scope.data.currentCountry.code;
        $scope.model.phone = $scope.data.currentCountry.phone_prefix;
      }
    }, true);

    $scope.$watchCollection('[model.name, model.login, model.password, model.phone, model.terms, model.pincode]',
        function(newValues, oldValues) {
          $scope.inlineMessage = '';
        });

  }
})();
